import { FC, PropsWithChildren, ReactElement } from 'react';

import './TableFoot.scss';

interface TableFootProps {
    className?: string;
}

const TableFoot: FC<PropsWithChildren<TableFootProps>> = ({ className = '', children }): ReactElement => (
    <tfoot className={`table-foot ${className}`}>
        {children}
    </tfoot>
);

export default TableFoot;
